<template>
  <VContainer class="pb-12">
    <h1 class="mb-4 title">
      {{ $t('passReset') }}
    </h1>
    <VDivider class="mt-2" />

    <VFlex xs12 sm6 md4 class="mx-auto mb">
      <div class="mt-md-12 mt-6">
        <VForm @submit.prevent="resetPassword">
          <VTextField
            v-model="password"
            class="mb-md-7 mb-3"
            :label="$t('newPass')"
            type="password"
            outlined
            dense
            autocomplete="new-password"
            :error-messages="errors.password"
          />
          <VTextField
            v-model="passwordConfirmation"
            class="mb-md-7 mb-3"
            :label="$t('confirmPass')"
            type="password"
            outlined
            dense
            autocomplete="new-password"
            :error-messages="errors.passwordConfirmation"
          />
          <VLayout column align-center class="text-center">
            <div v-if="hasErrorMessageOnly" class="mt-5 red--text">
              {{ errorMessage }}
            </div>
            <VBtn
              color="success"
              dark
              elevation="0"
              class="mt-5"
              type="submit"
              :loading="loading"
            >
              {{ $t('reset') }}
            </VBtn>
          </VLayout>
        </VForm>
      </div>
      <VFlex d-flex class="mt-5 flex-column align-center flex-md-row justify-center">
        <RouterLink to="/registration" class="text-decoration-none">
          {{ $t('registration') }}
        </RouterLink>
      </VFlex>
      <VFlex d-flex class="mt-5 flex-column align-center flex-md-row justify-center">
        <RouterLink to="/login" class="text-decoration-none">
          {{ $t('login') }}
        </RouterLink>
      </VFlex>
    </VFlex>
  </VContainer>
</template>

<script>
import ValidationMixin from '../mixins/ValidationMixin';
import User from '../orm/models/User/User';

export default {
  name: 'ResetPassword',
  metaInfo() {
    return {
      title: this.$t('passReset'),
    };
  },
  mixins: [ValidationMixin],
  data: () => ({
    login: null,
    password: null,
    passwordConfirmation: null,
    token: null,
  }),
  created() {
    const data = this.$route.query;
    if ('email' in data) {
      this.login = data.email;
    }

    if ('token' in data) {
      this.token = data.token;
    }
  },
  methods: {
    async resetPassword() {
      this.withValidationHandling(async () => {
        await User.api().resetPassword({
          login: this.login,
          password: this.password,
          passwordConfirmation: this.passwordConfirmation,
          token: this.token,
        });
        await this.$router.push('/login');
      });
    },
  },
};
</script>

<i18n locale="en" lang="yaml">
  passReset: Reset password
  newPass: New password
  confirmPass: Confirm password
  reset: Reset
  registration: Registration
  login: Login
</i18n>

<i18n locale="ru" lang="yaml">
  passReset: Восстановление пароля
  newPass: Новый пароль
  confirmPass: Еще раз
  reset: Восстановить
  registration: Регистрация
  login: Вход
</i18n>
